import { IGPKeyInitiative } from 'legacy/lut/classes/models/partner360/IGPKeyInitiative'
import { serializeDescriptionQualityResult } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/descriptionQuality/mappers'

import { normalizeKeyInitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { IGPKeyInitiativeForm } from '../models/gpKeyInitiativeForm'

export const mapFormToGPKeyInitiative = (
  formData: IGPKeyInitiativeForm,
  isInvestmentNeeds: boolean
) => {
  const result: Partial<IGPKeyInitiative> = {
    EntryId: formData.entryId,
    PreviousEntryId: formData.previousEntryId,
    Status: normalizeKeyInitiativeStatus(formData.status),
    Name: formData.name || '',
    Development: formData.keyObjective,
    KeyObjectiveTags: formData.keyObjectiveTags?.join(',') || '',
    Period: formData.period.join(','),
    Owner: formData.owner,
    ActivityType: formData.activityType,
    AddToBridges: formData.shouldAddToBridges ? 1 : 0,
    DataInsightRelated: formData.isDataInsightRelated ? 1 : 0,
    Currency: formData.currency,
    ValueType: formData.valueType,
    BusinessUnit: formData.businessUnit,
    FocusArea: formData.focusArea,
    Description: formData.description,
    DescriptionQuality: serializeDescriptionQualityResult(formData.descriptionQuality),
    HPInvestmentSum: formData.hpInvestmentSum,
    HPInvestmentSource: formData.hpInvestmentSource,
    InitType: formData.initType,
    GoalDescription: formData.goalDescription,
    ProofOfExecution: formData.proofOfExecution,
    IsAchieved: formData.isAchieved ? 1 : 0,
    CountriesAffectedList: formData.countriesAffectedList.join(','),
    IsCountriesAffected: Number(formData.isCountriesAffected),
  }

  if (formData.isAchieved === null) {
    result.IsAchieved = null
  }

  switch (formData.valueType) {
    // TODO: ActualsValueTypes.UTNet
    case 'UTNet':
      result.GoalUTNet = formData.goalUTNet
      result.GoalUTNetUSD = formData.goalUTNetUsd
      result.GoalUTNetLocalCurrency = formData.goalUTNetLocalCurrency
      result.IncrementalUTNet = formData.incrementalUTNet
      result.IncrementalUTNetUSD = formData.incrementalUTNetUsd
      result.IncrementalUTNetLocalCurrency = formData.incrementalUTNetLocalCurrency
      break

    case ActualsValueTypes.TNet:
      result.GoalTNet = formData.goalTNet
      result.GoalTNetUSD = formData.goalTNetUsd
      result.GoalTNetLocalCurrency = formData.goalTNetLocalCurrency
      result.IncrementalTNet = formData.incrementalTNet
      result.IncrementalTNetUSD = formData.incrementalTNetUsd
      result.IncrementalTNetLocalCurrency = formData.incrementalTNetLocalCurrency
      break

    case ActualsValueTypes.Net:
      result.GoalNet = formData.goalNet
      result.GoalNetUSD = formData.goalNetUsd
      result.GoalNetLocalCurrency = formData.goalNetLocalCurrency
      result.IncrementalNet = formData.incrementalNet
      result.IncrementalNetUSD = formData.incrementalNetUsd
      result.IncrementalNetLocalCurrency = formData.incrementalNetLocalCurrency
      break

    default:
    case ActualsValueTypes.Ndp:
      result.GoalNdp = formData.goalNdp
      result.GoalNdpUSD = formData.goalNdpUsd
      result.GoalNdpLocalCurrency = formData.goalNdpLocalCurrency
      result.IncrementalNdp = formData.incrementalNdp
      result.IncrementalNdpUSD = formData.incrementalNdpUsd
      result.IncrementalNdpLocalCurrency = formData.incrementalNdpLocalCurrency
      break
  }

  if (!isInvestmentNeeds) {
    delete result.HPInvestmentSum
    delete result.HPInvestmentSource
  }

  return result
}
